import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";

import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal } from "antd";
import moment from "moment";

const ClsListview = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [clsData, setClsData] = useState([]);
  const [allData, setAllData] = useState([]);

  const { sendRequest: getcontainerLoadingSupervision } = useHttp();

  const getData = () => {
    getcontainerLoadingSupervision(
      {
        url: "/api/containerLoadingSupervision/",
      },
      (res) => {
        if (res) {
          //console.log(res);
          const sortedData = res.sort((a, b) => b.clsId - a.clsId);
          setData(sortedData);
          // setData(res);
          setClsData(res[0]);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.clSupervisionNo.includes(filetrtext) ||
        item.employeeName.includes(filetrtext) ||
        item.containerNo.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const { sendRequest: clsDelete } = useHttp();

  const handleDelete = (e, clsId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content:
        "Are you sure you want to delete this Arrival Quality Check detail?",
      onOk() {
        const data = {
          clsId: clsId,
          serviceId: serviceId,
        };
        //console.log(data);

        clsDelete(
          {
            url: "/api/containerLoadingSupervision/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            getData();
          }
        );
      },
      onCancel() {},
    });
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

 

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Container Loading Supervision
            </label>
          </div>

          <div className="col-6 text-right">
            {canDelete === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Container Supervision
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>CLS Date</th>
                          <th>InspectionTime</th>
                          <th>Doc No</th>
                          <th>Assigned Supervisor </th>
                          <th>Container No</th>
                          <th>Container Temperature</th>
                          <th>Container Condition</th>
                       
                          {canEdit === "block" && <th>Edit</th>}
                          {canDelete === "block" && <th>Delete</th>}
                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.clsDate}</td>
                                <td>
                                  {moment(
                                    itm.inspectionTime,
                                    "HH:mm:ss"
                                  ).format("hh:mm A")}
                                </td>
                                <td>{itm.clSupervisionNo}</td>
                                <td>{itm.employeeName}</td>

                                <td>{itm.containerNo}</td>
                                <td>{itm.containerTemperature}</td>
                                <td>{itm.containerCondition}</td>
                          
                                {canEdit === "block" && (
                                  <td>
                                    <button
                                      onClick={() => {
                                        props.addForm(true);
                                        sId(serviceId);
                                        props.update(itm);
                                      }}
                                      className="btn"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  </td>
                                )}
                                {canDelete === "block" && (
                                  <td>
                                    <button
                                      type="button"
                                      onClick={(e) => handleDelete(e, itm)}
                                      className="btn"
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </td>
                                )}
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      //  onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    
    </>
  );
};

export default ClsListview;
